export const getContacts = state => state.contacts.items;
export const getFilter = state => state.contacts.filter;
